
export class StringUtils
{
    public static ToTitleCase(str: string): string
    {
        return str.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    }

    public static FormatName(name?: string): string
    {
        return this.ToTitleCase(name || "(brak nazwiska)").trim();
    }

    public static FormatMoney(amount: number): string
    {
        // Convert the amount to integer (remove decimals), then insert apostrophes as thousands separator
        const integerAmount = Math.round(amount);
        return integerAmount
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, "'")
            + " zł";
    }
}
